export default __webpack_public_path__ + "static/media/icons8-txt.aba35fe8.svg";